import fly from 'flyio';
import { onSend, onSucceed, onError } from './helper';

fly.config.baseURL = '/app_api/v1';
fly.config.timeout = 15000;
fly.interceptors.request.use(onSend);
fly.interceptors.response.use(onSucceed, onError);

export { fly };
